var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconBottle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-bottle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161154",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31312"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31309"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31308",
  clipPath: "url(#icon-bottle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38589",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31311"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31310",
  clipPath: "url(#icon-bottle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38590",
  d: "M23.545 21.79a3.191 3.191 0 01-.83-2.147v-1.729a1.161 1.161 0 011.161-1.161h16.248a1.161 1.161 0 011.161 1.161v1.731a3.192 3.192 0 01-.83 2.147 3.192 3.192 0 00-.83 2.147v3.923a3.192 3.192 0 00.83 2.147 3.192 3.192 0 01.83 2.147v18.2a3.568 3.568 0 01-3.567 3.568H26.283a3.568 3.568 0 01-3.568-3.568v-18.2a3.191 3.191 0 01.83-2.147 3.191 3.191 0 00.83-2.147v-3.923a3.191 3.191 0 00-.83-2.147",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38591",
  d: "M37.717 54.735H26.282a4.39 4.39 0 01-4.385-4.385v-18.2a4 4 0 011.043-2.7 2.368 2.368 0 00.617-1.6v-3.914a2.368 2.368 0 00-.617-1.6 4 4 0 01-1.043-2.7v-1.724a1.981 1.981 0 011.979-1.979h16.248a1.981 1.981 0 011.979 1.979v1.731a4 4 0 01-1.043 2.7 2.369 2.369 0 00-.617 1.6v3.923a2.368 2.368 0 00.617 1.6 4 4 0 011.043 2.7v18.2a4.39 4.39 0 01-4.385 4.385M23.876 17.569a.343.343 0 00-.343.343v1.731a2.368 2.368 0 00.617 1.6 4 4 0 011.043 2.7v3.923a4 4 0 01-1.043 2.7 2.369 2.369 0 00-.617 1.6v18.2a2.753 2.753 0 002.75 2.75h11.434a2.753 2.753 0 002.75-2.75v-18.2a2.368 2.368 0 00-.617-1.6 4 4 0 01-1.042-2.7v-3.93a4 4 0 011.042-2.7 2.368 2.368 0 00.617-1.6v-1.724a.343.343 0 00-.343-.343z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38592",
  d: "M40.454 12.66H23.542a.827.827 0 00-.827.827v2.436a.827.827 0 00.827.827h16.912a.827.827 0 00.827-.827v-2.438a.827.827 0 00-.827-.827",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38593",
  d: "M40.397 17.569H23.603a1.708 1.708 0 01-1.706-1.706v-2.315a1.708 1.708 0 011.706-1.706h16.794a1.708 1.708 0 011.706 1.706v2.315a1.708 1.708 0 01-1.706 1.706m-16.794-4.091a.07.07 0 00-.07.07v2.315a.07.07 0 00.07.07h16.794a.07.07 0 00.07-.07v-2.315a.07.07 0 00-.07-.07z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161155",
  fill: "#fff",
  d: "M29.023 9.961h5.983v2.7h-5.983z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38594",
  d: "M35.006 13.478h-5.987a.818.818 0 01-.818-.818v-2.7a.818.818 0 01.818-.817h5.983a.818.818 0 01.818.818v2.7a.818.818 0 01-.818.818m-5.162-1.636h4.347v-1.065H29.84z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1436",
  fill: "#fff",
  d: "M39.49 24.56h-3.745"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38595",
  d: "M39.49 25.379h-3.745a.818.818 0 010-1.636h3.745a.818.818 0 110 1.636",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1437",
  fill: "#fff",
  d: "M39.49 27.253h-3.745"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38596",
  d: "M39.49 28.071h-3.745a.818.818 0 110-1.636h3.745a.818.818 0 110 1.636",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1438",
  fill: "#fff",
  d: "M28.352 24.56h-3.745"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38597",
  d: "M28.353 25.379h-3.745a.818.818 0 010-1.636h3.745a.818.818 0 010 1.636",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1439",
  fill: "#fff",
  d: "M28.352 27.253h-3.745"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38598",
  d: "M28.353 28.071h-3.745a.818.818 0 110-1.636h3.745a.818.818 0 110 1.636",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38599",
  d: "M41.285 54.039H25.667a2.952 2.952 0 01-2.952-2.952v-6.333h18.57z",
  fill: "#273d8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38600",
  d: "M41.285 54.858h-15.4a3.991 3.991 0 01-3.986-3.986v-6.117a.818.818 0 01.818-.818h18.57a.818.818 0 01.818.818v9.282a.818.818 0 01-.818.818M23.535 45.57v5.3a2.353 2.353 0 002.351 2.351h14.581v-7.65z",
  fill: "#283c8c"
}))))));
export default __webpack_public_path__ + "static/icon-bottle.f678678712547d5266e6bd97ff30456c.svg";
export { SvgIconBottle as ReactComponent };